import Vue from 'vue';
import removeHttp from "./base/removeHttp";
import openUrl from "./base/openUrl";
import base from "./base/base";
import vipComputedMixin from "./computed/vip";
Vue.mixin(base);
Vue.mixin(openUrl);
Vue.mixin(removeHttp);
Vue.mixin(vipComputedMixin);